/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ProfileOwnResponse } from '../models/ProfileOwnResponse';
import type { ProfileOwnSepaUpdateDto } from '../models/ProfileOwnSepaUpdateDto';
import type { ProfileOwnUpdateDataDto } from '../models/ProfileOwnUpdateDataDto';
import type { ProfileOwnUpdateDto } from '../models/ProfileOwnUpdateDto';
import type { ProfileOwnUpdatePasswordDto } from '../models/ProfileOwnUpdatePasswordDto';
import type { SuccessResponse } from '../models/SuccessResponse';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class OwnProfileService {

    /**
     * @returns ProfileOwnResponse
     * @throws ApiError
     */
    public static fetchOwnProfile(): CancelablePromise<ProfileOwnResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/own-profile',
        });
    }

    /**
     * @param requestBody
     * @returns any
     * @throws ApiError
     */
    public static updateOwnProfile(
        requestBody: ProfileOwnUpdateDto,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/own-profile',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @param requestBody
     * @returns any
     * @throws ApiError
     */
    public static updateSepaProfile(
        requestBody: ProfileOwnSepaUpdateDto,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/own-profile-sepa',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @param requestBody
     * @returns any
     * @throws ApiError
     */
    public static updateOwnData(
        requestBody: ProfileOwnUpdateDataDto,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/own-profile/data',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @param requestBody
     * @returns SuccessResponse
     * @throws ApiError
     */
    public static updatePassword(
        requestBody: ProfileOwnUpdatePasswordDto,
    ): CancelablePromise<SuccessResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/update-own-password',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @returns SuccessResponse
     * @throws ApiError
     */
    public static enrolledBetatester(): CancelablePromise<SuccessResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/enroll-betatester',
        });
    }

    /**
     * @returns SuccessResponse
     * @throws ApiError
     */
    public static derollBetatester(): CancelablePromise<SuccessResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/deroll-betatester',
        });
    }

}
